import { useCallback, useState } from 'react';

// Clicking the sorted column flips it; any other column starts ascending. Pass the
// direction words the table's comparator checks ('asc'/'desc' or 'ascending'/'descending').
export const useSortConfig = (initial = null, [asc, desc] = ['asc', 'desc']) => {
  const [sortConfig, setSortConfig] = useState(initial);
  const requestSort = useCallback((key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev && prev.key === key && prev.direction === asc ? desc : asc,
    }));
  }, [asc, desc]);
  return [sortConfig, requestSort, setSortConfig];
};
